import { Avatar } from 'antd';

const PALETTE = ['#FB3C7F', '#7C3AED', '#2563EB', '#059669', '#D97706', '#DC2626', '#0891B2', '#9333EA'];

/** A stable colour for a seed, so the same person always gets the same avatar. */
function colourFor(seed: string): string {
  let h = 0;
  for (let i = 0; i < seed.length; i++) h = (h * 31 + seed.charCodeAt(i)) >>> 0;
  return PALETTE[h % PALETTE.length] ?? '#FB3C7F';
}

/**
 * Initials avatar for a user or listener. The apps render bundled artwork for
 * `avatarSeed`; the panel has no copy of that artwork, so it shows initials in a
 * colour derived from the seed (or id) instead — enough to tell two rows apart
 * at a glance, which is the point.
 */
export function PersonAvatar({
  name,
  seed,
  size = 32,
}: {
  /** Display name or @handle. */
  name: string | null | undefined;
  /** avatarSeed, id — anything stable per person. */
  seed: string | null | undefined;
  size?: number;
}) {
  const clean = (name ?? '').replace(/^@/, '').trim();
  const initials = clean
    ? clean
        .split(/[\s_.-]+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0]!.toUpperCase())
        .join('')
    : '?';
  return (
    <Avatar
      size={size}
      style={{ backgroundColor: colourFor(seed || clean || '?'), fontWeight: 600, flex: 'none' }}
      aria-hidden
    >
      {initials}
    </Avatar>
  );
}
